import initStore from '../store/redux/initStore';
import AuthManager from '../utils/authManager';
import JwtManager from '../utils/jwtManager';
import { i18nextInit } from './i18n';
import { setPermission } from '../store/stores/user/permission.store';
import { setMenu } from '../store/stores/user/menu.store';
import { setUser } from '../store/stores/user/user.store';
import axiosInstance from './axios';
import { setStoredCompanyTimeZone } from '../utils/timezone';

const initApp = async () => {
  await i18nextInit();

  let currentUser = null;

  try {
    if (JwtManager.accessToken) {
      currentUser = await AuthManager.getUserFromToken(JwtManager.accessToken);

      try {
        const companyResponse = await axiosInstance.get('api/company');
        const companyTimeZone = companyResponse?.data?.timeZone ?? companyResponse?.data?.TimeZone;
        if (companyTimeZone) {
          setStoredCompanyTimeZone(companyTimeZone);
          if (currentUser?.user) {
            (currentUser.user as any).companyTimeZone = companyTimeZone;
          }
        }
      } catch {
        // keep running with defaults when timezone cannot be fetched
      }
    }
  } catch (e) {
  }

  const appStore = initStore(
    currentUser,
    localStorage.getItem('i18nextLng') ?? 'it'
  );

  if (currentUser) {
    appStore.dispatch(setPermission(currentUser.permissions));
    appStore.dispatch(setMenu(currentUser.menu));
    appStore.dispatch(setUser(currentUser.user));
  }

  return appStore;
};

export default initApp;
